module.exports = __webpack_public_path__ + "media/images/payment/3dvisa-458909d3bff51bd1a21c6c2656407d2b.png";